export default __webpack_public_path__ + "static/media/fans-empty-state.edf4b15b.png";